import {
  useInvestorCompanies,
  useLatestFinancialReportsFromIdArray,
} from '@/hooks/useStore';
import { mapToKey } from '@/utils/arrays';
import CompaniesCard from './CompaniesCard';
import TotalInvestedCard from './TotalInvestedCard';
import CurrentValueCard from './CurrentValueCard';
import ProfitLossCard from './ProfitLossCard';
import InvestorsCard from './InvestorsCard';
import InvestmentsCard from './InvestmentsCard';
import { classes, sumTotalInvestments } from './utils';

export {
  CompaniesCard,
  TotalInvestedCard,
  CurrentValueCard,
  ProfitLossCard,
  InvestorsCard,
  InvestmentsCard,
};

export type InsightsCardsProps = {
  isFetchingData?: boolean;
  investorId: number;
};

export default function InsightsCards({ investorId }: InsightsCardsProps) {
  const investorCompanies = useInvestorCompanies(investorId);
  const latestReports = useLatestFinancialReportsFromIdArray(
    mapToKey(investorCompanies, 'companyId')
  );
  const summary = sumTotalInvestments(investorCompanies, latestReports);

  return (
    <div className={classes.wrapper}>
      <CompaniesCard count={summary.companyCount} />
      <TotalInvestedCard totalInvested={summary.totalInvested} />
      <CurrentValueCard currentValue={summary.currentValue} />
      <ProfitLossCard
        companyCount={investorCompanies.length}
        missingCompanyCount={summary.missingCompanyCount}
        profitLoss={summary.profitLoss}
      />
    </div>
  );
}
